export const handleVideoData = (data) => {
  const blob = new Blob(data.recordedChunks, {
    type: "video/webm",
  });
  const formData = new FormData();
  const myFile = new File([blob], "demo.mp4", { type: "video/mp4" });
  formData.append("video_file", myFile);
  formData.append("title", "demo");
  formData.append("onb_type", data?.type);

  return formData;
};
